import { Injectable } from '@angular/core';
import { createWorker, OEM, PSM, Worker } from 'tesseract.js';

export interface OcrConfig {
   charWhitelist: string;
   charBlacklist: string;
   confidenceThreshold: number;
}

export interface OcrResult {
   text: string;
   confidence: number;
   imageData?: string;
}

@Injectable({ providedIn: 'root' })
export class OcrEngineService {
   private worker: Worker | null = null;
   private initialized = false;

   async initialize(config: OcrConfig): Promise<void> {
      if (this.initialized) return;

      try {
         this.worker = await createWorker();
         await this.worker.load();
         await this.worker.setParameters({
            tessedit_pageseg_mode: PSM.SINGLE_BLOCK,
            tessedit_char_whitelist: config.charWhitelist,
            tessedit_char_blacklist: config.charBlacklist,
            tessedit_ocr_engine_mode: OEM.LSTM_ONLY,
            preserve_interword_spaces: '0',
            tessedit_confidence_threshold: config.confidenceThreshold.toString()
         });
         this.initialized = true;
      } catch (error) {
         console.error('OCR initialization failed:', error);
         throw new Error('OCR engine initialization failed');
      }
   }

   async recognize(imageData: string): Promise<OcrResult> {
      if (!this.worker) throw new Error('OCR engine not initialized');

      const { data: { text, confidence } } = await this.worker.recognize(imageData);
      return {
         text: text.trim(),
         confidence,
         imageData
      };
   }

   async terminate(): Promise<void> {
      if (this.worker) {
         await this.worker.terminate();
         this.worker = null;
      }
      this.initialized = false;
   }
}